import React, { useEffect, useState } from 'react';
import { HR, ResultedTicket, ResultedTicketItem } from './styled';
import Text from '../../ui/Text';
import {
    formatDate,
    formatDenmarkCurrency,
    isTerminal,
} from '../../utils/UiHelper';

const Big9Turnover = ({ isResultPage = false, payoutsData = {} }) => {
    const [seventh, setSeventh] = useState('');
    const [eighth, setEighth] = useState('');
    const [ninth, setNinth] = useState('');

    useEffect(
        () => {
            if (Object.keys(payoutsData?.payouts).length > 0) {
                setSeventh(getCorrectItem(0));
                setEighth(getCorrectItem(1));
                setNinth(getCorrectItem(2));
            }
        },
        [payoutsData]
    );

    const getCorrectItem = (item) => {
        if (isResultPage) {
            let qualifyingUnits = '';
            if (
                payoutsData?.payouts[item]?.unitDividend === 0 ||
                payoutsData?.payouts[item]?.jackpot
            ) {
                qualifyingUnits = '';
            } else {
                qualifyingUnits = `(${formatDenmarkCurrency(
                    Number(payoutsData?.payouts[item]?.qualifyingUnits),
                    0
                )} vindere)`;
            }
            return `${formatDenmarkCurrency(
                Number(payoutsData?.payouts[item]?.unitDividend) / 100,
                0
            )} kr. ${qualifyingUnits}`;
        } else {
            return `${formatDenmarkCurrency(
                Number(payoutsData?.payouts[item]?.pot) / 100,
                0
            )} kr.`;
        }
    };

    return (
        <ResultedTicket className={isResultPage ? 'isResultPage' : null}>
            <ResultedTicketItem>
                <Text
                    size={isTerminal() ? '16' : '14'}
                    bold
                    margin="0"
                    padding="0"
                    color="#333333"
                >
                    {isTerminal()
                        ? isResultPage
                            ? ' Omsætning BIG 9'
                            : 'Samlet pulje'
                        : ' Omsætning BIG 9'}
                    {!isResultPage && payoutsData?.poolUpdated > 0
                        ? ` (${formatDate(payoutsData?.poolUpdated, 'HH:mm')})`
                        : null}
                </Text>
                <Text
                    size={isTerminal() ? '16' : '14'}
                    bold
                    align="right"
                    margin="0"
                    padding="0"
                    color="#333333"
                >
                    {payoutsData?.turnover
                        ? formatDenmarkCurrency(payoutsData?.turnover / 100, 0)
                        : '0'}{' '}
                    kr.
                </Text>
            </ResultedTicketItem>
            <ResultedTicketItem margin={'0'}>
                <Text
                    size={isTerminal() ? '16' : '14'}
                    bold
                    margin="0"
                    padding="0"
                    color="#333333"
                >
                    Antal systemer
                </Text>
                <Text
                    size={isTerminal() ? '16' : '14'}
                    bold
                    align="right"
                    margin="0"
                    padding="0"
                    color="#333333"
                >
                    {payoutsData?.numberOfSystems
                        ? formatDenmarkCurrency(
                              Number(payoutsData?.numberOfSystems),
                              0
                          )
                        : '0'}{' '}
                    st
                </Text>
            </ResultedTicketItem>

            {isResultPage ? (
                <>
                    <HR margin={'20px auto'} />
                    <ResultedTicketItem>
                        <Text
                            size={isTerminal() ? '16' : '14'}
                            margin="0"
                            padding="0"
                            color="#333333"
                        >
                            9 rigtige
                        </Text>
                        <Text
                            size={isTerminal() ? '16' : '14'}
                            align="right"
                            margin="0"
                            padding="0"
                            color="#333333"
                        >
                            {seventh}
                        </Text>
                    </ResultedTicketItem>
                    <ResultedTicketItem>
                        <Text
                            size={isTerminal() ? '16' : '14'}
                            margin="0"
                            padding="0"
                            color="#333333"
                        >
                            8 rigtige
                        </Text>
                        <Text
                            size={isTerminal() ? '16' : '14'}
                            align="right"
                            margin="0"
                            padding="0"
                            color="#333333"
                        >
                            {eighth}
                        </Text>
                    </ResultedTicketItem>
                    <ResultedTicketItem>
                        <Text
                            size={isTerminal() ? '16' : '14'}
                            margin="0"
                            padding="0"
                            color="#333333"
                        >
                            7 rigtige
                        </Text>
                        <Text
                            size={isTerminal() ? '16' : '14'}
                            align="right"
                            margin="0"
                            padding="0"
                            color="#333333"
                        >
                            {ninth}
                        </Text>
                    </ResultedTicketItem>
                </>
            ) : null}
        </ResultedTicket>
    );
};

export default Big9Turnover;
